import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { defineComponent, watchEffect ,onMounted, reactive} from "vue";
import {useRoute} from "vue-router";
import stateStore from "./utils/store";
import storeControle from "./utils/storeControle";
import {getToken} from "./utils/funcoes";

import LoginCliente from "./pages/cliente/Login.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


const stateStoreInstance = stateStore;
const route = useRoute();

var controle = reactive({
  rota: ""
})

onMounted(()=> {
    console.log("montando...");
    document.body.classList.add("bg-body-secondary");
    storeControle.token = getToken();
})

watchEffect(async () => {
  if (stateStoreInstance.open) {
      document.body.classList.remove("sidebar-show");
      document.body.classList.add("sidebar-hide");
    } else {
      document.body.classList.remove("sidebar-hide");
      document.body.classList.add("sidebar-show");
  }
})

function getTokenCliente() {
  const x = localStorage.getItem("clienteToken");

  if (x != null) {
   return x;
  }
  return "";
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})